<template>
  <div class="text" :class="$mq">
    <span>Die Welt der Wagnerianer:</span><br />
    Von Venedig über Lettland, Israel, Abu Dhabi und die USA bis nach Japan.
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.text {
  color: white;
  width: 100%;
  text-align: center;
  padding: 1em 2em 2em 2em;
  font-size: 1.6rem;
  span {
    font-size: 2.1rem;
  }
  &.sm {
    padding: 1em;
    font-size: 1rem;
    span {
      font-size: 1.5rem;
    }
  }
  &.sm,
  &.md {
    padding-bottom: 2em;
  }
}
</style>
